/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CopyIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABSklEQVR4nN2UO07DQBCGXUEBR4CaCtFBC0UkS2geLtYzPBo4Bh1dStLAGUCRkKCnyRXgBtAFRIAiDQpae02ME7w2cRNGmsLS7P/N/DveIPi3QbS/DiQdZLlHlg9kHU0kSa+2cBiGi0h6DiSfU0VzCST92uLAeucEhskEqFut1uFS0EQAyYUTf9yN4o1GRAueW1uGmTiRrCJLF1jfivZk5xDjo4rd65nztZOJA+nzb/5/A9Lvth/A+mCLmfc204PSLbvgAsAPAdJ3W2iMWXbACVswl+M6eaoEKelsNC2JZNvVtX+urp42AgCWG1tnjFmwkMIkxzMDMF2Ik1LfZwVg8lzoLWK8k91J8wAu37IxgKSXf1saBxRj/gHg+dGwdLv0tcIEcv3nCUgu/QA0a8jyUr976UfRwUpQJZLnmvQKWQZ+cRnYziuLz018AQPWAY5BOPvYAAAAAElFTkSuQmCC)
 */
export const CopyIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3 16a1 1 0 0 1-1-1v-5a8 8 0 0 1 8-8h5a1 1 0 0 1 1 1v.5a.5.5 0 0 1-.5.5H10a6 6 0 0 0-6 6v5.5a.5.5 0 0 1-.5.5H3Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M6 18a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4v-4h-3a5 5 0 0 1-5-5V6h-4a4 4 0 0 0-4 4v8Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.73 12a3 3 0 0 0-.6-.88l-4.25-4.24a3 3 0 0 0-.88-.61V9a3 3 0 0 0 3 3h2.73Z"
        className={colorClass}
      />
    </svg>
  );
};
